"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ValidationError = require("./ValidationError");

var _ValidationError2 = _interopRequireDefault(_ValidationError);

var _RadioGroupOption = require("./RadioGroupOption");

var _RadioGroupOption2 = _interopRequireDefault(_RadioGroupOption);

var _RadioGroupLabel = require("./RadioGroupLabel");

var _RadioGroupLabel2 = _interopRequireDefault(_RadioGroupLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioGroup = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(RadioGroup, _Component);

  function RadioGroup() {
    (0, _classCallCheck3.default)(this, RadioGroup);
    return (0, _possibleConstructorReturn3.default)(this, (RadioGroup.__proto__ || (0, _getPrototypeOf2.default)(RadioGroup)).apply(this, arguments));
  }

  (0, _createClass3.default)(RadioGroup, [{
    key: "render",
    value: function render() {
      var fieldProps = this.props.fieldProps;

      var hasError = fieldProps.touched && fieldProps.error;
      var formGroupClasses = "form-group radio-group";

      if (hasError) {
        formGroupClasses += " has-error";
      }

      return _react2.default.createElement(
        "div",
        { className: formGroupClasses },
        this.renderTitle(),
        this.renderOptions(),
        _react2.default.createElement(_ValidationError2.default, { fieldProps: this.props.fieldProps })
      );
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var title = this.props.title;

      if (title) {
        return _react2.default.createElement(
          "h2",
          { className: "h5" },
          title
        );
      }
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var _props = this.props,
          fieldProps = _props.fieldProps,
          name = _props.name;

      return this.props.options.map(function (option, index) {
        return _react2.default.createElement(
          "div",
          { className: "radio-group-button", key: option.id + "_" + index },
          _react2.default.createElement(_RadioGroupOption2.default, { name: name, option: option, fieldProps: fieldProps }),
          _react2.default.createElement(_RadioGroupLabel2.default, { option: option })
        );
      });
    }
  }]);
  return RadioGroup;
}(_react.Component), _class.propTypes = {
  options: _react.PropTypes.array.isRequired,
  fieldProps: _react.PropTypes.object.isRequired,
  title: _react.PropTypes.string,
  name: _react.PropTypes.string.isRequired
}, _temp);
exports.default = RadioGroup;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/form/RadioGroup.js
 ** module id = 206
 ** module chunks = 0
 **/